// Alaine's Compass — starter co-manufacturer directory.
// Compiled July 2026 from public sources: Penn State Extension, Cornell Food Venture Center,
// Minnesota Dept. of Agriculture, Utah Dept. of Agriculture, UC Davis Food Quality, Mass.gov,
// PickYourOwn's co-packer list, University of Tennessee Food Science, UGA Extension (Georgia),
// Texas A&M Aggie Horticulture, and the Colorado Dept. of Agriculture Co-Pack Directory.
// Details (especially MOQs) change often — always confirm directly with the co-packer.
// Ratings start empty and fill in from member reviews.

export const COMAN_DIRECTORY = [
  {
    "id": "cm-001",
    "name": "All Seasons Kitchen",
    "city": "Mohnton",
    "state": "PA",
    "profiles": [
      "sauce",
      "dressing"
    ],
    "moq": "",
    "website": "https://www.allseasonskitchen.com/",
    "notes": "They process and package a variety of sauces and dressings.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-002",
    "name": "Bylers Relish House",
    "city": "Saegertown",
    "state": "PA",
    "profiles": [
      "sauce",
      "salsa"
    ],
    "moq": "",
    "website": "https://bylersrelishhouse.com/",
    "notes": "They specialize in relish, salsa, and acidified canned foods.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-003",
    "name": "Case by Case",
    "city": "Philadelphia",
    "state": "PA",
    "profiles": [
      "sauce",
      "savory-snack"
    ],
    "moq": "",
    "website": "https://casepaper.com/",
    "notes": "They provide turnkey solutions and specialize in small-batch bottling and pouching for start-ups.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-004",
    "name": "Con Yeager Spice Company",
    "city": "New Castle",
    "state": "PA",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "",
    "website": "https://www.conyeagerspice.com/",
    "notes": "They offer custom blending and private label services for spices and seasonings.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-005",
    "name": "Crave Copacking",
    "city": "Verona",
    "state": "PA",
    "profiles": [
      "sauce",
      "salsa",
      "dressing"
    ],
    "moq": "low moq",
    "website": "https://cravecp.com/",
    "notes": "They focus on pickles, sauces, and beverage mixes with low minimum order quantities.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-006",
    "name": "Farmer's Choice Food Brands",
    "city": "Closter",
    "state": "NJ",
    "profiles": [
      "sauce",
      "dressing"
    ],
    "moq": "",
    "website": "https://www.farmerschoicefoods.com/",
    "notes": "They specialize in small-batch production of sauces, dressings, and jellies.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-007",
    "name": "Grouse Hunt Farms Inc.",
    "city": "Tamaqua",
    "state": "PA",
    "profiles": [
      "sauce",
      "salsa",
      "dressing"
    ],
    "moq": "",
    "website": "https://www.wos-wit.com/",
    "notes": "They offer co-packing and private label services for Pennsylvania Dutch style foods.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-008",
    "name": "Hinkle Fine Foods, Inc.",
    "city": "Dayton",
    "state": "OH",
    "profiles": [
      "sauce",
      "salsa",
      "dressing",
      "refrigerated-dip"
    ],
    "moq": "",
    "website": "https://hinklefinefoods.com/",
    "notes": "This SQF certified facility handles a wide range of sauces, dips, and spreads.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-009",
    "name": "Janus Food Group Inc.",
    "city": "Northumberland",
    "state": "PA",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "http://www.janusfoodgroup.com/",
    "notes": "They specialize in Tetra Recart packaging and are Organic, Kosher, and Gluten-Free certified.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-010",
    "name": "Lancaster Fine Foods (Stir Foods)",
    "city": "Lancaster",
    "state": "PA",
    "profiles": [
      "sauce",
      "salsa",
      "dressing"
    ],
    "moq": "",
    "website": "https://stirfoods.com/",
    "notes": "They provide services for various sauces, fruit spreads, and salad dressings.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-011",
    "name": "Longo's Bakery Inc.",
    "city": "Hazleton",
    "state": "PA",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "",
    "notes": "They offer co-packing and private label services for pizza-related products and sauces.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-012",
    "name": "Mama Vida Inc.",
    "city": "Randallstown",
    "state": "MD",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "",
    "notes": "They specialize in small batch production of acidified foods.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-013",
    "name": "Maryland Packaging",
    "city": "Elkridge",
    "state": "MD",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "https://marylandpackaging.com/",
    "notes": "They offer commercial juicing and various co-packing services.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-014",
    "name": "Millennium Packaging Service, Inc.",
    "city": "Carbondale",
    "state": "PA",
    "profiles": [
      "dry-seasoning",
      "savory-snack"
    ],
    "moq": "",
    "website": "http://www.mil-pkg.com/",
    "notes": "An SQF, Organic, and Kosher certified facility specializing in various flexible packaging solutions.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-015",
    "name": "Neilly's Food Development",
    "city": "York",
    "state": "PA",
    "profiles": [
      "dry-seasoning",
      "sauce",
      "dressing"
    ],
    "moq": "low moq",
    "website": "",
    "notes": "They focus on low-MOQ custom formulations for dry mixes, sauces, and baked goods.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-016",
    "name": "Palace Foods, Inc.",
    "city": "Reading",
    "state": "PA",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "https://palacefoodsinc.com/",
    "notes": "They provide co-packing for sauces, mixes, and oils.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-017",
    "name": "Pellegrino Foods",
    "city": "Warren",
    "state": "PA",
    "profiles": [
      "frozen",
      "sauce"
    ],
    "moq": "",
    "website": "http://www.pellegrinofoods.com/",
    "notes": "They are a co-packer for frozen foods and specialty sauces.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-018",
    "name": "Rocky Mountain Spice Co.",
    "city": "Denver",
    "state": "CO",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "",
    "website": "https://rockymountainspice.com/",
    "notes": "They provide bulk spice, seasoning, and baking mix co-packing and private label services.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-019",
    "name": "Select Juice LLC.",
    "city": "Lancaster",
    "state": "PA",
    "profiles": [
      "frozen"
    ],
    "moq": "",
    "website": "https://www.selectjuice.llc/",
    "notes": "An SQF certified facility specializing in functional beverages, cold-fill, and hot-fill processes.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-020",
    "name": "Stello Foods, Inc.",
    "city": "Punxsutawney",
    "state": "PA",
    "profiles": [
      "sauce",
      "salsa",
      "dressing"
    ],
    "moq": "",
    "website": "https://stellofoods.com/",
    "notes": "They specialize in a variety of sauces, salsas, mustards, and marinades.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-021",
    "name": "The Organic Food Incubator",
    "city": "Bloomfield",
    "state": "NJ",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "https://organicfoodincubator.com/",
    "notes": "They specialize in serving start-ups with small-batch production for beverages and sauces in a nut-free facility.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-022",
    "name": "Telmark Packaging",
    "city": "Red Bank",
    "state": "NJ",
    "profiles": [
      "sauce",
      "dry-seasoning",
      "dressing"
    ],
    "moq": "",
    "website": "https://www.telmarkpkg.com/",
    "notes": "They offer co-manufacturing and co-packaging for a wide range of products including sauces and supplements.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-023",
    "name": "Tulkoff Food Products",
    "city": "Baltimore",
    "state": "MD",
    "profiles": [
      "sauce",
      "dressing"
    ],
    "moq": "",
    "website": "https://www.tulkoff.com/",
    "notes": "They are an SQF and FDA certified manufacturer of condiments and specialty sauces.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-024",
    "name": "Victoria Packing",
    "city": "Brooklyn",
    "state": "NY",
    "profiles": [
      "sauce",
      "salsa",
      "refrigerated-dip"
    ],
    "moq": "",
    "website": "https://victoriapastasauces.com/",
    "notes": "They offer co-packing and private label programs for sauces and various food service items.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-025",
    "name": "Winter Gardens Quality Foods, Inc.",
    "city": "New Oxford",
    "state": "PA",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "",
    "notes": "They are an SQF level 2 inspected facility producing soups, sauces, and entrees.",
    "source": "Penn State Extension"
  },
  {
    "id": "cm-026",
    "name": "California Spice Basket",
    "city": "",
    "state": "CA",
    "profiles": [
      "sauce",
      "dry-seasoning"
    ],
    "moq": "small batch minimum",
    "website": "",
    "notes": "They specialize in small batch sauce and seasoning co-packing.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-027",
    "name": "Ready Foods",
    "city": "",
    "state": "CO",
    "profiles": [
      "sauce",
      "meal-kit"
    ],
    "moq": "",
    "website": "",
    "notes": "A co-packer offering sauce and meal kit manufacturing services.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-028",
    "name": "D&M Packing, LLC",
    "city": "",
    "state": "CT",
    "profiles": [
      "sauce",
      "dry-seasoning"
    ],
    "moq": "",
    "website": "",
    "notes": "A Connecticut-based co-packer for sauces and dry seasonings.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-029",
    "name": "Foodnovation Design",
    "city": "",
    "state": "CT",
    "profiles": [
      "savory-snack",
      "sauce",
      "dry-seasoning"
    ],
    "moq": "",
    "website": "https://www.foodnovation.design/",
    "notes": "Co-packer specializing in snacks, sauces, and dry mixes.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-030",
    "name": "Gourmet Products, Inc",
    "city": "",
    "state": "CT",
    "profiles": [
      "sauce",
      "refrigerated-dip"
    ],
    "moq": "80-90 gals.",
    "website": "",
    "notes": "Co-packer specializing in sauces and dips.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-031",
    "name": "Onofrio’s Ultimate Foods",
    "city": "",
    "state": "CT",
    "profiles": [
      "sauce",
      "dry-seasoning"
    ],
    "moq": "25 cases min.",
    "website": "",
    "notes": "Connecticut-based manufacturer for sauces and dry seasonings.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-032",
    "name": "Palmieri Food Products, Inc",
    "city": "",
    "state": "CT",
    "profiles": [
      "sauce",
      "salsa",
      "dressing"
    ],
    "moq": "",
    "website": "",
    "notes": "Co-packer for various sauces, salsas, and dressings.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-033",
    "name": "National Foodwork Services",
    "city": "",
    "state": "IL",
    "profiles": [
      "savory-snack"
    ],
    "moq": "Flexible minimums",
    "website": "http://nationalfoodworks.com/",
    "notes": "Manufacturer offering flexible minimums for snack products.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-034",
    "name": "PacMoore Innovation Lab",
    "city": "",
    "state": "IL",
    "profiles": [
      "savory-snack"
    ],
    "moq": "at least an 8 hour production run",
    "website": "https://www.pacmoore.com/contract-manufacturing/processing/extrusion/",
    "notes": "Specializes in snack food extrusion and production runs.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-035",
    "name": "PacMoore Products Inc.",
    "city": "",
    "state": "IN",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "at least an 8 hour production run",
    "website": "https://www.pacmoore.com",
    "notes": "Specializes in large-scale dry blending and seasoning production.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-036",
    "name": "G.M. Allen",
    "city": "",
    "state": "ME",
    "profiles": [
      "frozen"
    ],
    "moq": "",
    "website": "",
    "notes": "Co-packer focused on frozen food products.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-037",
    "name": "A.M. Look Canning Co.",
    "city": "",
    "state": "ME",
    "profiles": [
      "sauce",
      "meal-kit"
    ],
    "moq": "",
    "website": "",
    "notes": "Maine-based producer of sauces and meal kits.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-038",
    "name": "DennyMike's Sauces & Seasonings",
    "city": "",
    "state": "ME",
    "profiles": [
      "sauce",
      "dry-seasoning"
    ],
    "moq": "",
    "website": "http://www.dennymikes.com/",
    "notes": "Small-batch friendly partner for sauces and seasonings.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-039",
    "name": "Hockomock Bottling Company, Inc.",
    "city": "",
    "state": "ME",
    "profiles": [
      "sauce",
      "dry-seasoning"
    ],
    "moq": "100-150 gals.",
    "website": "",
    "notes": "Co-packer for liquid sauces and dry mixes.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-040",
    "name": "Pemberton’s Foods, Inc.",
    "city": "",
    "state": "ME",
    "profiles": [
      "sauce",
      "salsa",
      "dressing"
    ],
    "moq": "",
    "website": "",
    "notes": "Co-packer specializing in sauces, salsas, and dressings.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-041",
    "name": "Portland Shellfish Co.",
    "city": "",
    "state": "ME",
    "profiles": [
      "frozen"
    ],
    "moq": "",
    "website": "",
    "notes": "Co-packer for frozen shellfish products.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-043",
    "name": "Tulkoff Food Products, Inc.",
    "city": "",
    "state": "MD",
    "profiles": [
      "sauce"
    ],
    "moq": "40,000 cases annually per SKU",
    "website": "http://www.tulkoff.com/",
    "notes": "Large-scale manufacturer of specialty sauces and condiments.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-044",
    "name": "Avon Food Company",
    "city": "",
    "state": "MA",
    "profiles": [
      "sauce",
      "dry-seasoning"
    ],
    "moq": "",
    "website": "https://avonfood.com/",
    "notes": "Co-packer based in Massachusetts for sauces and dry ingredients.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-045",
    "name": "Cape Cod Provisions",
    "city": "",
    "state": "MA",
    "profiles": [
      "savory-snack"
    ],
    "moq": "",
    "website": "https://www.capecodprovisions.com/",
    "notes": "Specializes in snack food co-packing.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-048",
    "name": "Hans Kissle, Co.",
    "city": "",
    "state": "MA",
    "profiles": [
      "savory-snack"
    ],
    "moq": "3000 lbs.",
    "website": "",
    "notes": "Snack manufacturer with 3000 lb minimums.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-050",
    "name": "Plenus Group, Inc",
    "city": "",
    "state": "MA",
    "profiles": [
      "sauce",
      "frozen"
    ],
    "moq": "",
    "website": "",
    "notes": "Co-packer for sauces and frozen meal components.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-051",
    "name": "Traverse Bay Farms",
    "city": "",
    "state": "MI",
    "profiles": [
      "salsa"
    ],
    "moq": "",
    "website": "https://www.traversebayfarms.com/",
    "notes": "Salsa and fruit-based product co-packer.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-052",
    "name": "Genuine Local",
    "city": "",
    "state": "NH",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "http://www.genuinelocal.org/",
    "notes": "Co-packer for locally produced sauces.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-053",
    "name": "Neighbor Made",
    "city": "",
    "state": "NH",
    "profiles": [
      "sauce",
      "dry-seasoning"
    ],
    "moq": "",
    "website": "",
    "notes": "Co-packer for sauces and dry seasoning mixes.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-054",
    "name": "Ark Foods",
    "city": "",
    "state": "NJ",
    "profiles": [
      "savory-snack"
    ],
    "moq": "",
    "website": "https://www.arkfoods.com",
    "notes": "Manufacturer specializing in snack food products.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-055",
    "name": "Black River Spice & Tea, LLC",
    "city": "",
    "state": "NJ",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "",
    "website": "http://www.blackriverspice.com/",
    "notes": "Specializes in dry spice and tea blending.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-056",
    "name": "Salt Road Food Hub",
    "city": "",
    "state": "NJ",
    "profiles": [
      "sauce",
      "dry-seasoning"
    ],
    "moq": "",
    "website": "https://www.saltroadfoodhub.com/",
    "notes": "Co-packing hub for sauces and dry goods.",
    "source": "Cornell Food Venture Center"
  },
  {
    "id": "cm-057",
    "name": "Mille Lacs Wild Rice Corporation",
    "city": "Aitkin",
    "state": "MN",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "typically no order minimums",
    "website": "https://canoewildrice.com/",
    "notes": "Can pack any style or size of dry food packaging.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-058",
    "name": "Particle Control Inc.",
    "city": "Albertville",
    "state": "MN",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "100 pounds",
    "website": "https://www.particlecontrolinc.com/",
    "notes": "Specializes in toll milling, blending, and dry packaging.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-059",
    "name": "Northwestern Foods Inc.",
    "city": "Arden Hills",
    "state": "MN",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "2,000 pounds/item",
    "website": "http://northwestern.n2ocompanies.com/",
    "notes": "Certified kosher and halal, BRC audited facility offering dry blending.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-060",
    "name": "Riffs Smokehouse",
    "city": "Arden Hills",
    "state": "MN",
    "profiles": [
      "sauce"
    ],
    "moq": "varies by product",
    "website": "https://www.riffssmokehouse.com/",
    "notes": "Full USDA certified meat facility that also packs BBQ and other sauces.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-061",
    "name": "Buddy's Kitchen Inc.",
    "city": "Burnsville",
    "state": "MN",
    "profiles": [
      "frozen"
    ],
    "moq": "negotiable",
    "website": "http://www.buddyskitchen.com/",
    "notes": "Offers frozen meal co-packing and selectively works with early-stage companies.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-062",
    "name": "Sno Pac Foods",
    "city": "Caledonia",
    "state": "MN",
    "profiles": [
      "frozen"
    ],
    "moq": "20,000 pounds for packaging",
    "website": "http://www.snopac.com/",
    "notes": "Organic certified vegetable frozen food co-packer.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-063",
    "name": "Great River Organic Milling",
    "city": "Cochrane",
    "state": "MN",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "depends on product",
    "website": "http://www.greatrivermilling.com/",
    "notes": "Processes organic whole grains, flours, and cereal mixes.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-064",
    "name": "Hamel Maple Syrup Company Inc.",
    "city": "Hamel",
    "state": "MN",
    "profiles": [
      "sauce"
    ],
    "moq": "pallet preferred",
    "website": "http://www.hamelsyrup.com/",
    "notes": "SQF, kosher, and organic certified maple syrup and sugar bottling.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-065",
    "name": "Croix Valley Foods",
    "city": "Hudson",
    "state": "WI",
    "profiles": [
      "sauce",
      "dry-seasoning"
    ],
    "moq": "100 gallons liquid / 150 pounds dry",
    "website": "https://www.croixvalleyfoods.com/pages/copacking",
    "notes": "Focuses on acidic/acidified canned foods and dry rubs.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-066",
    "name": "TWT Sauce Inc.",
    "city": "Hudson",
    "state": "WI",
    "profiles": [
      "sauce",
      "salsa"
    ],
    "moq": "varies by product",
    "website": "",
    "notes": "Small-batch friendly, gluten-free facility for acidic/acidified foods.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-067",
    "name": "Maud Borup",
    "city": "Le Center",
    "state": "MN",
    "profiles": [
      "savory-snack",
      "dry-seasoning",
      "sauce"
    ],
    "moq": "4,000 units",
    "website": "https://www.maudborup.com/",
    "notes": "Experienced in private label manufacturing for both food and non-food items.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-068",
    "name": "North Star Processing LLC",
    "city": "Litchfield",
    "state": "MN",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "varies with products",
    "website": "http://www.nsp-llc.com/",
    "notes": "Kosher and organic certified facility specializing in spray-dried powders.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-069",
    "name": "Lakeside Foods Inc.",
    "city": "Manitowoc",
    "state": "WI",
    "profiles": [
      "frozen",
      "salsa",
      "sauce"
    ],
    "moq": "n/a",
    "website": "http://lakesidefoods.com/channels/co-packing/",
    "notes": "Focuses 100% on private brand for canned/frozen vegetables.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-070",
    "name": "All American Foods Inc.",
    "city": "Mankato",
    "state": "MN",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "to be determined",
    "website": "http://www.aafoods.com/",
    "notes": "Specializes in custom processing of dry and co-dried food ingredients.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-071",
    "name": "Stone Gate Foods",
    "city": "Shakopee",
    "state": "MN",
    "profiles": [
      "frozen",
      "meal-kit"
    ],
    "moq": "1 full production day",
    "website": "http://www.stonegate-foods.com/",
    "notes": "Expertise in high hand-labor products like appetizers, pizzas, and meal kits.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-072",
    "name": "At Last! Gourmet Foods",
    "city": "Minneapolis",
    "state": "MN",
    "profiles": [
      "sauce",
      "refrigerated-dip"
    ],
    "moq": "1 pallet (1,200 pounds)",
    "website": "https://www.atlastgourmetfoods.com/",
    "notes": "USDA inspected, SQF level II facility focusing on sustainable liquid/spreadable products.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-073",
    "name": "Bare Honey & Co. Food Manufacturing",
    "city": "Minneapolis",
    "state": "MN",
    "profiles": [
      "sauce"
    ],
    "moq": "200 gallons",
    "website": "https://barehoney.com/",
    "notes": "Certified organic and HACCP-planned manufacturer for honey, jams, and mixers.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-074",
    "name": "Fischer's United Supply Inc.",
    "city": "Minneapolis",
    "state": "MN",
    "profiles": [
      "sauce",
      "dressing",
      "refrigerated-dip"
    ],
    "moq": "500 pounds",
    "website": "http://bakerschoicebrands.com/",
    "notes": "USDA organic certified facility packing various condiment sizes from jars to drums.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-075",
    "name": "Gourmet CoPack",
    "city": "Minneapolis",
    "state": "MN",
    "profiles": [
      "sauce"
    ],
    "moq": "1,000 units",
    "website": "https://gourmetcopack.com/",
    "notes": "Specializes in preserves, pickles, and sauces.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-076",
    "name": "Karlsburger Foods Inc.",
    "city": "Monticello",
    "state": "MN",
    "profiles": [
      "sauce",
      "dry-seasoning"
    ],
    "moq": "no min stock / 150 lbs custom blend",
    "website": "http://www.karlsburger.com/",
    "notes": "SQF, organic, and halal certified producer of soup bases and seasonings.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-077",
    "name": "Krienke Foods International Inc.",
    "city": "Mountain Lake",
    "state": "MN",
    "profiles": [
      "savory-snack"
    ],
    "moq": "negotiable",
    "website": "",
    "notes": "SQF-certified snack manufacturer specializing in roasting and frying legumes and grains.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-078",
    "name": "The Secret Garden",
    "city": "Park Rapids",
    "state": "MN",
    "profiles": [
      "dry-seasoning",
      "meal-kit"
    ],
    "moq": "n/a",
    "website": "http://secretgardengourmet.com/",
    "notes": "Producer of dehydrated soups, dips, and meal/baking mixes.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-079",
    "name": "Smude Enterprises",
    "city": "Pierz",
    "state": "MN",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "any",
    "website": "http://www.smudeoil.com/",
    "notes": "Offers dry good co-packing and oil bottling services.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-080",
    "name": "Food Service Specialties",
    "city": "Red Wing",
    "state": "MN",
    "profiles": [
      "sauce",
      "refrigerated-dip"
    ],
    "moq": "1,000 gallons",
    "website": "http://www.foodservicespecialties.com/",
    "notes": "Specializes in tomato and dairy-based sauces for foodservice and remanufacturing.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-081",
    "name": "Kaye Family Foods",
    "city": "River Falls",
    "state": "WI",
    "profiles": [
      "sauce",
      "salsa"
    ],
    "moq": "no minimums",
    "website": "https://www.kayefamilyfoods.com/",
    "notes": "No-minimum co-packer specializing in BBQ sauces, salsa, and acidified foods.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-082",
    "name": "Chippewa Packaging Inc.",
    "city": "Saint Peter",
    "state": "MN",
    "profiles": [
      "savory-snack",
      "dry-seasoning"
    ],
    "moq": "to be determined",
    "website": "http://www.chippewapackaging.com/",
    "notes": "SQF level 3, organic and kosher certified facility for pouch/dry food packaging.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-083",
    "name": "Hemp Acres",
    "city": "Waconia",
    "state": "MN",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "varies",
    "website": "https://www.hempacresusa.com/",
    "notes": "Facility for hemp grain cleaning, pressing, blending, and liquid/powder filling.",
    "source": "Minnesota Dept. of Agriculture"
  },
  {
    "id": "cm-084",
    "name": "MZ Packaging",
    "city": "Salt Lake City",
    "state": "UT",
    "profiles": [
      "dry-seasoning",
      "sauce"
    ],
    "moq": "",
    "website": "https://mz-packaging.com/",
    "notes": "Comprehensive contract packaging for dry mixes, sauces, and spices.",
    "source": "Utah Dept. of Agriculture"
  },
  {
    "id": "cm-085",
    "name": "Cornaby's Specialty Foods",
    "city": "Payson",
    "state": "UT",
    "profiles": [
      "dressing",
      "sauce",
      "salsa"
    ],
    "moq": "",
    "website": "http://cornabys.com",
    "notes": "Manufacturer of sauces, dressings, and fruit-based spreads.",
    "source": "Utah Dept. of Agriculture"
  },
  {
    "id": "cm-086",
    "name": "Snack Connector",
    "city": "SALT LAKE CITY",
    "state": "UT",
    "profiles": [
      "savory-snack"
    ],
    "moq": "",
    "website": "",
    "notes": "Specializes in snack food and grain product co-packing.",
    "source": "Utah Dept. of Agriculture"
  },
  {
    "id": "cm-087",
    "name": "Propeller Co-Pack",
    "city": "Santaquin",
    "state": "UT",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "",
    "website": "https://propellercopack.com/",
    "notes": "Co-packer for dry mixes, grains, and dry ingredients.",
    "source": "Utah Dept. of Agriculture"
  },
  {
    "id": "cm-089",
    "name": "Mrs. Auld's Gourmet Foods",
    "city": "Reno",
    "state": "NV",
    "profiles": [
      "salsa"
    ],
    "moq": "",
    "website": "",
    "notes": "Co-packer specializing in pickles and salsa.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-090",
    "name": "E. Waldo Ward & Son",
    "city": "",
    "state": "CA",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "https://waldoward.com/",
    "notes": "Traditional producer of jams, jellies, and sauces.",
    "source": "UC Davis Food Quality"
  },
  {
    "id": "cm-091",
    "name": "Maison de Monaco",
    "city": "",
    "state": "CA",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "https://maisondemonaco.com",
    "notes": "Specializes in artisanal jams and fruit spreads.",
    "source": "UC Davis Food Quality"
  },
  {
    "id": "cm-092",
    "name": "RW Garcia Co. Inc.",
    "city": "",
    "state": "CA",
    "profiles": [
      "savory-snack"
    ],
    "moq": "",
    "website": "http://www.rwgarcia.co",
    "notes": "Specializes in snacks and tortilla chip production.",
    "source": "UC Davis Food Quality"
  },
  {
    "id": "cm-093",
    "name": "Santa Barbara Olive Co., Inc.",
    "city": "",
    "state": "CA",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "http://www.sbolive.com",
    "notes": "Specializes in olives and jarred condiments.",
    "source": "UC Davis Food Quality"
  },
  {
    "id": "cm-094",
    "name": "Sonoma Gourmet",
    "city": "",
    "state": "CA",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "https://www.sonomagourmet.com/",
    "notes": "Specializes in premium jarred sauces.",
    "source": "UC Davis Food Quality"
  },
  {
    "id": "cm-095",
    "name": "Thatcher's Gourmet Popcorn",
    "city": "",
    "state": "CA",
    "profiles": [
      "savory-snack"
    ],
    "moq": "",
    "website": "http://www.tgsp.com",
    "notes": "Specializes in gourmet popcorn production.",
    "source": "UC Davis Food Quality"
  },
  {
    "id": "cm-096",
    "name": "Alfredo's Italian Foods, Mfg. Co. Inc.",
    "city": "Quincy",
    "state": "MA",
    "profiles": [
      "frozen"
    ],
    "moq": "5000 lbs pasta",
    "website": "http://www.aapasta.com/",
    "notes": "Specializes in frozen pasta products.",
    "source": "Mass.gov co-packer list"
  },
  {
    "id": "cm-097",
    "name": "Arbor Hill Grapery",
    "city": "Naples",
    "state": "NY",
    "profiles": [
      "sauce"
    ],
    "moq": "25 cases hours",
    "website": "http://www.thegrapery.com/",
    "notes": "Produces sauces and preserves.",
    "source": "Mass.gov co-packer list"
  },
  {
    "id": "cm-098",
    "name": "Bake'n Joy Foods, Inc.",
    "city": "North Andover",
    "state": "MA",
    "profiles": [
      "dry-seasoning",
      "sauce",
      "frozen"
    ],
    "moq": "dry 7000 lbs/month min frozen 2600 lbs/ mon",
    "website": "",
    "notes": "Offers co-packing for dry mixes, sauces, and frozen goods.",
    "source": "Mass.gov co-packer list"
  },
  {
    "id": "cm-099",
    "name": "Boxford Bakehouse",
    "city": "Plymouth",
    "state": "MA",
    "profiles": [
      "dry-seasoning",
      "frozen"
    ],
    "moq": "5,000 units",
    "website": "",
    "notes": "Co-packer for dry mixes and frozen baked goods.",
    "source": "Mass.gov co-packer list"
  },
  {
    "id": "cm-100",
    "name": "Casa Visco Finer Foods",
    "city": "Schenectady",
    "state": "NY",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "https://casavisco.com/distributor-private-label/",
    "notes": "Specializes in private label sauce production.",
    "source": "Mass.gov co-packer list"
  },
  {
    "id": "cm-101",
    "name": "Gold Pure Food Products Co. Inc.",
    "city": "Hempstead",
    "state": "NY",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "http://www.goldshorseradish.com/",
    "notes": "Manufacturer of specialty sauces.",
    "source": "Mass.gov co-packer list"
  },
  {
    "id": "cm-102",
    "name": "Gracie’s Kitchens Inc.",
    "city": "New Haven",
    "state": "CT",
    "profiles": [
      "sauce",
      "refrigerated-dip"
    ],
    "moq": "100 gal",
    "website": "https://www.gracieskitchens.com/",
    "notes": "Co-packer for sauces and dips.",
    "source": "Mass.gov co-packer list"
  },
  {
    "id": "cm-103",
    "name": "Hometown Foods LLC",
    "city": "Kinderhook",
    "state": "NY",
    "profiles": [
      "frozen",
      "meal-kit"
    ],
    "moq": "",
    "website": "",
    "notes": "Co-packer for frozen meals and meal kits.",
    "source": "Mass.gov co-packer list"
  },
  {
    "id": "cm-105",
    "name": "Lidestri Foods",
    "city": "Fairport",
    "state": "NY",
    "profiles": [
      "sauce",
      "refrigerated-dip"
    ],
    "moq": "",
    "website": "",
    "notes": "Major co-packer for sauces and dips.",
    "source": "Mass.gov co-packer list"
  },
  {
    "id": "cm-106",
    "name": "Look's Gourmet Food Co.",
    "city": "Whiting",
    "state": "ME",
    "profiles": [
      "sauce",
      "refrigerated-dip"
    ],
    "moq": "one pallet case",
    "website": "",
    "notes": "Co-packer for sauces and dips.",
    "source": "Mass.gov co-packer list"
  },
  {
    "id": "cm-107",
    "name": "Martin's Kitchen",
    "city": "Dundee",
    "state": "NY",
    "profiles": [
      "sauce"
    ],
    "moq": "15 gallons",
    "website": "",
    "notes": "Small-batch sauce producer.",
    "source": "Mass.gov co-packer list"
  },
  {
    "id": "cm-108",
    "name": "Pellicano's",
    "city": "Buffalo",
    "state": "NY",
    "profiles": [
      "sauce"
    ],
    "moq": "60 gallons cases",
    "website": "https://pellicanos.com/",
    "notes": "Specializes in sauce manufacturing.",
    "source": "Mass.gov co-packer list"
  },
  {
    "id": "cm-109",
    "name": "Plenus Group",
    "city": "Lowell",
    "state": "MA",
    "profiles": [
      "sauce",
      "frozen",
      "meal-kit"
    ],
    "moq": "800 lbs",
    "website": "",
    "notes": "Co-packer for meals and sauce-based kits.",
    "source": "Mass.gov co-packer list"
  },
  {
    "id": "cm-110",
    "name": "Quality Custom Packing",
    "city": "New Bedford",
    "state": "MA",
    "profiles": [
      "frozen",
      "savory-snack"
    ],
    "moq": "500",
    "website": "http://qualitycustompacking.com/",
    "notes": "Custom packer for frozen and snack goods.",
    "source": "Mass.gov co-packer list"
  },
  {
    "id": "cm-111",
    "name": "Sauces ‘n Love, Inc. /WEKOPAK LLC",
    "city": "Lynn",
    "state": "MA",
    "profiles": [
      "sauce",
      "frozen",
      "dressing",
      "salsa"
    ],
    "moq": "7,000 jars/day",
    "website": "http://saucesnlove.com/",
    "notes": "High-volume co-packer for sauces, frozen items, and dressings.",
    "source": "Mass.gov co-packer list"
  },
  {
    "id": "cm-112",
    "name": "Allegro Fine Foods",
    "city": "Paris",
    "state": "TN",
    "profiles": [
      "sauce",
      "dry-seasoning"
    ],
    "moq": "",
    "website": "http://allegromarinade.com/manufacturing/",
    "notes": "They pack sauces, marinades, seasonings, and liquid smokes.",
    "source": "University of Tennessee Food Science co-packer list"
  },
  {
    "id": "cm-113",
    "name": "Bell Buckle Country Store, Inc.",
    "city": "",
    "state": "TN",
    "profiles": [
      "sauce",
      "dressing"
    ],
    "moq": "",
    "website": "https://bellbucklecompanystore.com/pages/privatelabel",
    "notes": "They pack jams, jellies, pickles, chow chows, sauces, vanilla extract, glazes, hot and BBQ sauces, dressings, and toppings.",
    "source": "University of Tennessee Food Science co-packer list"
  },
  {
    "id": "cm-114",
    "name": "Chairmans Foods",
    "city": "Nashville",
    "state": "TN",
    "profiles": [
      "meal-kit",
      "sauce",
      "refrigerated-dip"
    ],
    "moq": "",
    "website": "http://www.chairmansfoods.com",
    "notes": "They pack specialty entrees, soups, chilis, sauces, gravies, queso, and side dishes.",
    "source": "University of Tennessee Food Science co-packer list"
  },
  {
    "id": "cm-115",
    "name": "Creative Spiceworks",
    "city": "",
    "state": "TN",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "",
    "website": "https://creativespiceworks.com/",
    "notes": "They pack seasoning solutions.",
    "source": "University of Tennessee Food Science co-packer list"
  },
  {
    "id": "cm-116",
    "name": "Das Jam Haus",
    "city": "Limestone",
    "state": "TN",
    "profiles": [
      "sauce",
      "salsa"
    ],
    "moq": "",
    "website": "http://www.dasjamhaus.com",
    "notes": "They pack jams, butters, syrups, canned fruit, pie filling, pickles, relish, sauces, and salsa.",
    "source": "University of Tennessee Food Science co-packer list"
  },
  {
    "id": "cm-117",
    "name": "Farm and Food",
    "city": "Nashville",
    "state": "TN",
    "profiles": [
      "sauce",
      "dry-seasoning",
      "dressing"
    ],
    "moq": "",
    "website": "http://furtherfoods.com",
    "notes": "They pack hot sauces, seasonings, relishes, condiments, and acidified foods.",
    "source": "University of Tennessee Food Science co-packer list"
  },
  {
    "id": "cm-118",
    "name": "Nashville Kitchen and Cannery",
    "city": "Dickson",
    "state": "TN",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "http://www.nashvillekitchenandcannery.com",
    "notes": "They pack jams, jellies, sauces, and acidified foods.",
    "source": "University of Tennessee Food Science co-packer list"
  },
  {
    "id": "cm-119",
    "name": "Pops’ Pepper Patch, Inc.",
    "city": "Louisville",
    "state": "KY",
    "profiles": [
      "sauce",
      "salsa",
      "dressing",
      "dry-seasoning"
    ],
    "moq": "",
    "website": "https://pops-pepper-patch-inc.myshopify.com/",
    "notes": "They pack pickles, hot, BBQ and other sauces, relishes, marinades, salsas, jellies, dressings, mustards, seasonings, and syrups.",
    "source": "University of Tennessee Food Science co-packer list"
  },
  {
    "id": "cm-120",
    "name": "Porky’s Gourmet Foods",
    "city": "Gallatin",
    "state": "TN",
    "profiles": [
      "sauce",
      "dry-seasoning",
      "dressing"
    ],
    "moq": "",
    "website": "http://porkysgourmet.com",
    "notes": "They pack sauces, relishes, seasonings, dry rubs, jellies, jams, and mustards.",
    "source": "University of Tennessee Food Science co-packer list"
  },
  {
    "id": "cm-121",
    "name": "Southern City Flavors",
    "city": "Goodlettsville",
    "state": "TN",
    "profiles": [
      "sauce",
      "salsa"
    ],
    "moq": "",
    "website": "http://southerncityflavors.com/",
    "notes": "They pack jams, pepper jellies, fruit butters, BBQ sauces, steak sauces, salsa, and syrups.",
    "source": "University of Tennessee Food Science co-packer list"
  },
  {
    "id": "cm-122",
    "name": "St. Clair Foods, Inc.",
    "city": "Memphis",
    "state": "TN",
    "profiles": [
      "frozen",
      "refrigerated-dip"
    ],
    "moq": "",
    "website": "http://www.stclair.com",
    "notes": "They pack chilled salads, frozen side dishes, entrees, and dips.",
    "source": "University of Tennessee Food Science co-packer list"
  },
  {
    "id": "cm-123",
    "name": "Sunbelt Packing Company",
    "city": "Atlanta",
    "state": "GA",
    "profiles": [
      "sauce",
      "dressing",
      "salsa",
      "dry-seasoning"
    ],
    "moq": "",
    "website": "https://sunbeltpackagingco.com/",
    "notes": "They pack sauces, marinades, dressings, condiments, salsas, jams, jellies, and seasonings.",
    "source": "University of Tennessee Food Science co-packer list"
  },
  {
    "id": "cm-124",
    "name": "Tennessee Gourmet",
    "city": "",
    "state": "TN",
    "profiles": [
      "sauce",
      "dressing"
    ],
    "moq": "",
    "website": "",
    "notes": "They pack jams, jellies, salad dressings, BBQ and other sauces.",
    "source": "University of Tennessee Food Science co-packer list"
  },
  {
    "id": "cm-125",
    "name": "The Pasta Shoppe, Inc.",
    "city": "Nashville",
    "state": "TN",
    "profiles": [
      "meal-kit",
      "sauce"
    ],
    "moq": "",
    "website": "",
    "notes": "They pack pasta, soups, sauces, and chilis.",
    "source": "University of Tennessee Food Science co-packer list"
  },
  {
    "id": "cm-126",
    "name": "A M Braswell Jr Food Co Inc",
    "city": "Statesboro",
    "state": "GA",
    "profiles": [
      "sauce",
      "dressing"
    ],
    "moq": "",
    "website": "",
    "notes": "Jellies, jams, preserves, sauces, dressings.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-127",
    "name": "Bella Cucina Artful Food",
    "city": "Atlanta",
    "state": "GA",
    "profiles": [
      "sauce"
    ],
    "moq": "25 case min",
    "website": "",
    "notes": "Jams, preserves, sauces, acidified foods.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-128",
    "name": "Blackberry Patch LLC",
    "city": "Thomasville",
    "state": "GA",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "",
    "notes": "Jams, jellies, preserves.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-129",
    "name": "Cedar Head Farms",
    "city": "Colquitt",
    "state": "GA",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "",
    "notes": "Jams, jellies, syrups.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-130",
    "name": "D and D Foods, Inc.",
    "city": "Columbus",
    "state": "GA",
    "profiles": [
      "sauce",
      "dressing"
    ],
    "moq": "200 gallon min",
    "website": "",
    "notes": "BBQ sauces, salad dressing, marinades.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-131",
    "name": "Diamond Crystal Brands, Bremen",
    "city": "Bremen",
    "state": "GA",
    "profiles": [
      "sauce",
      "dressing"
    ],
    "moq": "3600 case min run annually",
    "website": "",
    "notes": "Mayo, dressings, ketchup, mustard, jellies, jams, sauces, sugar substitutes.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-132",
    "name": "Diamond Crystal Brands, Duluth",
    "city": "Duluth",
    "state": "GA",
    "profiles": [
      "sauce",
      "dressing",
      "dry-seasoning"
    ],
    "moq": "typically must exceed 500 cases or 1 million units",
    "website": "",
    "notes": "Acidified foods, condiments, dressings, sauces, jams, jellies, honey, syrup, peanut butter, dry seasonings.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-133",
    "name": "Food Masters Inc.",
    "city": "Griffin",
    "state": "GA",
    "profiles": [
      "sauce",
      "dressing"
    ],
    "moq": "",
    "website": "",
    "notes": "Salad dressing, marinade, bbq sauce, etc.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-134",
    "name": "Georgia Spice Company",
    "city": "Atlanta",
    "state": "GA",
    "profiles": [
      "dry-seasoning",
      "dressing",
      "sauce"
    ],
    "moq": "1,000 lbs min",
    "website": "",
    "notes": "Dry blended ingredients, salad dressing, drink mixes, marinades, rubs, batters, snack seasoning.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-135",
    "name": "Hillside Orchard Farms, Inc.",
    "city": "Tiger",
    "state": "GA",
    "profiles": [
      "sauce"
    ],
    "moq": "50 gallon min",
    "website": "",
    "notes": "Acidified foods, jams, jellies, preserves, butters, juices.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-136",
    "name": "Jake's",
    "city": "White",
    "state": "GA",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "",
    "notes": "Jams, jellies, acid/acidified foods.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-137",
    "name": "Kabobs Acquisition LLC",
    "city": "Lake City",
    "state": "GA",
    "profiles": [
      "frozen"
    ],
    "moq": "",
    "website": "",
    "notes": "Frozen appetizers, entrees and ready to eat desserts.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-138",
    "name": "Little Spirit Foods, LLC",
    "city": "Hephzibah",
    "state": "GA",
    "profiles": [
      "dressing",
      "refrigerated-dip",
      "meal-kit"
    ],
    "moq": "",
    "website": "",
    "notes": "Juices, non-meat salads, dips, blends, non-meat soups.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-139",
    "name": "Maggie Lyon Inc",
    "city": "Norcross",
    "state": "GA",
    "profiles": [
      "sauce"
    ],
    "moq": "40 gallon min or 20 cases",
    "website": "",
    "notes": "Sauces.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-140",
    "name": "Mrs. Griffin'ss Barbecue Sauce",
    "city": "Macon",
    "state": "GA",
    "profiles": [
      "sauce",
      "dry-seasoning"
    ],
    "moq": "300 gallon min",
    "website": "",
    "notes": "Acidified & Acid Foods (BBQ Sauces, Dressings, Condiments), Dry mixes, Spice Blends.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-141",
    "name": "New Moon Kettle LLC",
    "city": "Clayton",
    "state": "GA",
    "profiles": [
      "savory-snack"
    ],
    "moq": "",
    "website": "",
    "notes": "Flavored Popcorn.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-142",
    "name": "Strickland Sauce Company",
    "city": "Athens",
    "state": "GA",
    "profiles": [
      "sauce"
    ],
    "moq": "125 gallon min or 800 btl",
    "website": "",
    "notes": "BBQ sauce, no particulates.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-143",
    "name": "Sugar Foods Corporation",
    "city": "Villa Rica",
    "state": "GA",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "",
    "website": "",
    "notes": "Dry portion items including croutons, creamer/sugar canisters, dry packets of sweeteners, seasonings, 4-6 oz portion items for soup/salad/oatmeal toppings.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-144",
    "name": "Superior Sauce Compay",
    "city": "Leesburg",
    "state": "GA",
    "profiles": [
      "sauce",
      "refrigerated-dip"
    ],
    "moq": "",
    "website": "",
    "notes": "Peanut butter, cheese sauces and other savory and sweet products packed in either portion cups or pouches.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-145",
    "name": "Thermo Pac",
    "city": "Stone Mountain",
    "state": "GA",
    "profiles": [
      "dressing",
      "sauce"
    ],
    "moq": "",
    "website": "",
    "notes": "Acidified dressings and sauces and peeled onions.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-146",
    "name": "Vidalia Valley LLC",
    "city": "Lyons",
    "state": "GA",
    "profiles": [
      "sauce",
      "salsa",
      "dressing",
      "dry-seasoning"
    ],
    "moq": "",
    "website": "",
    "notes": "Acid and Acidified Products: sauces, salsa, relishes, dressngs and dry seassoning blends.",
    "source": "UGA Extension Georgia co-packer list"
  },
  {
    "id": "cm-147",
    "name": "Absolutely World Class, Inc.",
    "city": "Abilene",
    "state": "TX",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "http://absolutelyworldclass.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-148",
    "name": "Afia Foods",
    "city": "Austin",
    "state": "TX",
    "profiles": [
      "frozen"
    ],
    "moq": "",
    "website": "https://www.afiafoods.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-149",
    "name": "ATX Specialty Foods",
    "city": "Austin",
    "state": "TX",
    "profiles": [
      "sauce",
      "salsa",
      "dressing"
    ],
    "moq": "",
    "website": "",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-150",
    "name": "Bay Valley Foods",
    "city": "San Antonio",
    "state": "TX",
    "profiles": [
      "sauce",
      "dressing"
    ],
    "moq": "",
    "website": "http://www.bayvalleyfoods.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-151",
    "name": "Bartush-Schnitzius Foods Co.",
    "city": "Lewisville",
    "state": "TX",
    "profiles": [
      "sauce",
      "dressing"
    ],
    "moq": "",
    "website": "http://www.bartushfoods.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-152",
    "name": "Claude’s Sauces",
    "city": "El Paso",
    "state": "TX",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "http://www.claudessauces.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-153",
    "name": "Consolidated Mills Inc.",
    "city": "Houston",
    "state": "TX",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-154",
    "name": "County Fair Foods, Inc",
    "city": "Arlington",
    "state": "TX",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "http://countyfairfoodsinc.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-155",
    "name": "Creative Food Works Inc.",
    "city": "San Antonio",
    "state": "TX",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-156",
    "name": "Fischer Wieser Specialty Foods",
    "city": "Fredericksburg",
    "state": "TX",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "http://www.jelly.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-157",
    "name": "Gourmet Cuisine",
    "city": "Mesquite",
    "state": "TX",
    "profiles": [
      "sauce",
      "meal-kit"
    ],
    "moq": "",
    "website": "http://www.gourmet-cuisine.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-158",
    "name": "Gourmet Recipe Experts, Inc.",
    "city": "Rusk",
    "state": "TX",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "http://www.uniquelygourmet.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-159",
    "name": "Henrys Dream",
    "city": "Houston",
    "state": "TX",
    "profiles": [
      "salsa"
    ],
    "moq": "",
    "website": "",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-160",
    "name": "Heritage Specialty Foods",
    "city": "Grand Prairie",
    "state": "TX",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "http://www.hfsfoods.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-161",
    "name": "Hill Country FoodWorks, LLC",
    "city": "Lockhart",
    "state": "TX",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "http://www.hillcountryfoodworks.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-162",
    "name": "Jardine Foods",
    "city": "Buda",
    "state": "TX",
    "profiles": [
      "sauce",
      "salsa"
    ],
    "moq": "",
    "website": "http://www.jardinefoods.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-163",
    "name": "Jelco Foods",
    "city": "Houston",
    "state": "TX",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-164",
    "name": "National Food & Beverage",
    "city": "Dallas",
    "state": "TX",
    "profiles": [
      "sauce",
      "salsa",
      "dressing"
    ],
    "moq": "",
    "website": "",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-165",
    "name": "New Canaan Farms",
    "city": "Utopia",
    "state": "TX",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "http://www.newcanaanfarms.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-166",
    "name": "Pack N Fresh",
    "city": "Grand Prairie",
    "state": "TX",
    "profiles": [
      "meal-kit"
    ],
    "moq": "",
    "website": "http://www.packnfresh.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-167",
    "name": "Picklesmith",
    "city": "Taft",
    "state": "TX",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "http://www.picklesmith.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-168",
    "name": "Renfro Foods",
    "city": "Ft. Worth",
    "state": "TX",
    "profiles": [
      "salsa",
      "sauce"
    ],
    "moq": "",
    "website": "http://www.renfrofoods.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-169",
    "name": "Riba Foods Inc.",
    "city": "Houston",
    "state": "TX",
    "profiles": [
      "sauce",
      "salsa"
    ],
    "moq": "",
    "website": "http://www.ribafoods.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-170",
    "name": "Ron’s Home Style Foods, Inc.",
    "city": "Houston",
    "state": "TX",
    "profiles": [
      "refrigerated-dip",
      "salsa",
      "sauce"
    ],
    "moq": "",
    "website": "http://www.ronsfoods.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-171",
    "name": "TexaFrance",
    "city": "Round Rock",
    "state": "TX",
    "profiles": [
      "sauce",
      "dressing"
    ],
    "moq": "",
    "website": "http://www.texafrance.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-172",
    "name": "Texas Tito’s, Inc.",
    "city": "New Braunfels",
    "state": "TX",
    "profiles": [
      "sauce",
      "refrigerated-dip"
    ],
    "moq": "",
    "website": "https://texastitos.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-173",
    "name": "Zilks Foods, LLC",
    "city": "Austin",
    "state": "TX",
    "profiles": [
      "refrigerated-dip",
      "salsa"
    ],
    "moq": "",
    "website": "http://www.zilksfoods.com/",
    "notes": "They pack acidified foods.",
    "source": "Texas A&M Aggie Horticulture co-packer list"
  },
  {
    "id": "cm-174",
    "name": "Awakened Foods",
    "city": "Loveland",
    "state": "CO",
    "profiles": [
      "savory-snack"
    ],
    "moq": "Typically 1-shift per flavor; approx 3,000-5,000 lb/flavor.",
    "website": "http://awakenedfoodcrafters.com",
    "notes": "They specialize in granola, cookies, nut mixes, extruded puffs, and compression popped chips.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-175",
    "name": "Basecamp Co-Pack",
    "city": "Denver",
    "state": "CO",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "Negotiable",
    "website": "http://basecampcopack.com",
    "notes": "They pack items such as powdered drink mixes and spices.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-176",
    "name": "Boulder Organic Foods",
    "city": "Niwot",
    "state": "CO",
    "profiles": [
      "sauce",
      "refrigerated-dip",
      "dressing"
    ],
    "moq": "250,000 lbs annually",
    "website": "http://boulderorganicfoods.com",
    "notes": "They specialize in kettle-cooked foods including fresh soups, dips, sauces, and gravy.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-177",
    "name": "Boulder Sausage",
    "city": "Louisville",
    "state": "CO",
    "profiles": [
      "savory-snack"
    ],
    "moq": "200 pounds",
    "website": "http://bouldersausage.com",
    "notes": "They produce meat, sausage, and prepared sausage products.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-178",
    "name": "Burns and McCoy Sauce Company",
    "city": "Fort Collins",
    "state": "CO",
    "profiles": [
      "dressing",
      "sauce",
      "dry-seasoning"
    ],
    "moq": "50 gallons",
    "website": "http://burnsandmccoy.com",
    "notes": "They pack dressings, pickles, sauces, flavoring, extracts, syrups, juices, and spices.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-179",
    "name": "Carefree Cuisine",
    "city": "Littleton",
    "state": "CO",
    "profiles": [
      "frozen"
    ],
    "moq": "",
    "website": "",
    "notes": "They pack items including meat/sausage, poultry, and frozen specialties.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-180",
    "name": "Claremont Foods",
    "city": "Westminster",
    "state": "CO",
    "profiles": [
      "meal-kit"
    ],
    "moq": "50,000 bars/SKU",
    "website": "http://claremontfoods.com",
    "notes": "They produce nutrition and protein bars.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-181",
    "name": "Colorado Copacking Company",
    "city": "Longmont",
    "state": "CO",
    "profiles": [
      "sauce",
      "dressing",
      "dry-seasoning"
    ],
    "moq": "50 Gallons",
    "website": "http://coloradocopacker.com",
    "notes": "They pack sauces, salsa, dressings, syrups, spices, condiments, and beverage mixers.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-182",
    "name": "Culinaire",
    "city": "Denver",
    "state": "CO",
    "profiles": [
      "frozen"
    ],
    "moq": "500/SKU",
    "website": "http://culinairefoods.com",
    "notes": "They produce meats, prepared foods, sausages, and frozen specialties.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-183",
    "name": "Custom Blending",
    "city": "Loveland",
    "state": "CO",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "Minimum bulk blend 50 pounds, minimum retail blend 200 pounds.",
    "website": "",
    "notes": "They pack spice blends, BBQ rubs, dry drink mixes, and various dry food ingredients.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-184",
    "name": "Deer Trail Gold Mining Company",
    "city": "Deer Trail",
    "state": "CO",
    "profiles": [
      "frozen"
    ],
    "moq": "",
    "website": "http://deertrailgoldmine.com",
    "notes": "They produce gourmet fudge, cold food prep, and frozen soups/stocks.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-185",
    "name": "Fish Ski Provisions",
    "city": "Alcalde",
    "state": "NM",
    "profiles": [
      "dry-seasoning",
      "savory-snack"
    ],
    "moq": "400 units",
    "website": "http://fishskiprovisions.com",
    "notes": "They pack spice blends, dry cooking mixes, pet treats, and nuts.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-186",
    "name": "Foremother Foods, LLC",
    "city": "Boulder",
    "state": "CO",
    "profiles": [
      "dressing",
      "sauce",
      "dry-seasoning"
    ],
    "moq": "500 lb. raw processing batch minimum, 300 lb. bulk fermentation batch minimum, 50 lb. dehydration batch minimum.",
    "website": "",
    "notes": "They produce lacto-fermented vegetables and dehydrated herbs and spices.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-187",
    "name": "Frangiosa Farms",
    "city": "Parker",
    "state": "CO",
    "profiles": [
      "dressing",
      "sauce"
    ],
    "moq": "5000",
    "website": "http://frangiosafarms.com",
    "notes": "They pack honey, infused honey, tinctures, and sauces.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-188",
    "name": "Freshies Food Corporation",
    "city": "Denver",
    "state": "CO",
    "profiles": [
      "dressing"
    ],
    "moq": "420 – 32 oz. bottles for a proprietary blend, 1 case for standard flavors",
    "website": "http://freshies.com",
    "notes": "They produce cocktail mixers and salt and sugar cocktail rimmers.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-189",
    "name": "Fuel Kitchens",
    "city": "Pueblo",
    "state": "CO",
    "profiles": [
      "sauce",
      "refrigerated-dip",
      "salsa",
      "dressing"
    ],
    "moq": "100 gallons per run, 1,000 gallons per year.",
    "website": "https://www.fuelkitchens.com/",
    "notes": "They pack hot sauces, salsas, salad dressings, BBQ sauces, and jams.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-190",
    "name": "Kim’s Gourmet Sauces",
    "city": "Castle Rock",
    "state": "CO",
    "profiles": [
      "dressing",
      "sauce",
      "salsa",
      "dry-seasoning"
    ],
    "moq": "40 gallons",
    "website": "http://kimsgourmet.com",
    "notes": "They pack BBQ sauces, teriyaki sauces, marinara sauces, and oil-based marinades.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-191",
    "name": "Kitchen Network Bottling Co.",
    "city": "Denver",
    "state": "CO",
    "profiles": [
      "dressing",
      "sauce",
      "salsa",
      "dry-seasoning"
    ],
    "moq": "100 gallons, exceptions can be made",
    "website": "",
    "notes": "They pack shelf-stable products such as salsas, sauces, condiments, and jams.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-192",
    "name": "Landmark Foods, LLC",
    "city": "Denver",
    "state": "CO",
    "profiles": [
      "sauce",
      "salsa",
      "dressing",
      "dry-seasoning"
    ],
    "moq": "",
    "website": "http://landmarkfoods.net",
    "notes": "They pack cocktail mixes, tea, salsa, sauces, marinades, and spice blends.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-193",
    "name": "Leroux Creek Foods",
    "city": "Hotchkiss",
    "state": "CO",
    "profiles": [
      "sauce",
      "salsa",
      "dressing"
    ],
    "moq": "Depends",
    "website": "http://lerouxcreek.com",
    "notes": "They produce organic applesauce, juice, sauerkraut, fruit purees, and dressings/sauces/salsas.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-194",
    "name": "Motherlode Co-Packing",
    "city": "Longmont",
    "state": "CO",
    "profiles": [
      "dressing",
      "sauce"
    ],
    "moq": "",
    "website": "http://motherlodecopacking.com",
    "notes": "They pack BBQ sauces, hot sauces, dressings, steak sauces, and general condiments.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-195",
    "name": "PRiMO Specialty Foods",
    "city": "Denver",
    "state": "CO",
    "profiles": [
      "dressing",
      "sauce",
      "refrigerated-dip"
    ],
    "moq": "None",
    "website": "http://yayprimo.com",
    "notes": "They produce fruit spreads, salad dressings, and dips.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-196",
    "name": "Rocky Mountain Food Factory, Inc.",
    "city": "Englewood",
    "state": "CO",
    "profiles": [
      "sauce",
      "salsa",
      "dressing",
      "refrigerated-dip",
      "frozen"
    ],
    "moq": "500 Pounds",
    "website": "http://rockymtnfoodfactory.com",
    "notes": "They produce ready-to-eat foods such as sauces, dips, and salad dressings.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-197",
    "name": "Rocky Mountain Gourmet Food Company",
    "city": "Castle Rock",
    "state": "CO",
    "profiles": [
      "sauce",
      "salsa",
      "dressing",
      "dry-seasoning"
    ],
    "moq": "",
    "website": "http://www.Facebook.com/RockyMountainGourmetFoodCompany",
    "notes": "They produce hot sauces, BBQ sauces, marinades, salsas, and seasonings.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-198",
    "name": "Rocky Mountain Spice Company",
    "city": "Denver",
    "state": "CO",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "5000 Units",
    "website": "http://rockymountainspice.com",
    "notes": "They produce dry mixes, rubs, cocoas, and spice blends.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-199",
    "name": "Scale Food Labs",
    "city": "Golden",
    "state": "CO",
    "profiles": [
      "sauce",
      "salsa",
      "dressing"
    ],
    "moq": "100 gallons, test batches are 5 gallons",
    "website": "http://scalefoodlabs.com",
    "notes": "They produce marinades, dipping sauces, tomato sauces, salsas, and BBQ sauce.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-200",
    "name": "Silver State Foods, Inc.",
    "city": "Denver",
    "state": "CO",
    "profiles": [
      "sauce",
      "dressing"
    ],
    "moq": "50 Gallons",
    "website": "http://silverstatefoods.com",
    "notes": "They pack pasta products and various sauces.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-201",
    "name": "Smart Cookie Barkery",
    "city": "Golden",
    "state": "CO",
    "profiles": [
      "savory-snack"
    ],
    "moq": "500 pounds/SKU",
    "website": "http://smartcookietreats.com/pages/private-label",
    "notes": "They pack savory dog treats, including biscuits and soft & chewy treats.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-202",
    "name": "Temptee Specialty Foods",
    "city": "Denver",
    "state": "CO",
    "profiles": [
      "frozen"
    ],
    "moq": "Depends on product and machinery needed",
    "website": "http://tempteeco.com",
    "notes": "They pack fresh/frozen foods, meats, eggs, and refrigerated/frozen specialty items.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-203",
    "name": "The Spice Guy",
    "city": "Aurora",
    "state": "CO",
    "profiles": [
      "dry-seasoning",
      "sauce"
    ],
    "moq": "Spices:  250 lbs    Acidified Foods:  50 gallons",
    "website": "http://thespiceguyco.com",
    "notes": "They pack spices, dry goods, hot sauces, BBQ sauce, and acidified foods.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-204",
    "name": "Trisco Foods",
    "city": "Colorado Springs",
    "state": "CO",
    "profiles": [
      "dressing",
      "sauce",
      "refrigerated-dip"
    ],
    "moq": "Short runs are welcome. Specific quantities determined for each product",
    "website": "http://triscofoods.com.au",
    "notes": "They produce shelf-stable sweet and savory liquids, including sauces, marinades, dips, and spreads.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-205",
    "name": "Western Innovations Inc.",
    "city": "Denver",
    "state": "CO",
    "profiles": [
      "sauce",
      "dry-seasoning"
    ],
    "moq": "Short runs are welcome. Specific quantities determined for each product",
    "website": "http://westerninnovationsinc.com",
    "notes": "They produce hot sauces and various powdered and liquid food products.",
    "source": "Colorado Dept. of Agriculture Co-Pack Directory"
  },
  {
    "id": "cm-206",
    "name": "Beaverton Foods",
    "city": "Hillsboro",
    "state": "OR",
    "profiles": [
      "sauce",
      "dressing"
    ],
    "moq": "",
    "website": "",
    "notes": "Beaverton Foods is a co-packer that specializes in creating gourmet private label lines for retailers.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-207",
    "name": "Bob's Red Mill",
    "city": "Milwaukie",
    "state": "OR",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "",
    "website": "",
    "notes": "They offer co-packing services for dry mixes.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-208",
    "name": "Bridgewell Agribusiness LLC",
    "city": "Clackamas",
    "state": "OR",
    "profiles": [
      "dry-seasoning"
    ],
    "moq": "Larger volumes only",
    "website": "",
    "notes": "They specialize in dry blending and packing with options for pouches, containers, and bulk packs.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-209",
    "name": "Chef George Inc.",
    "city": "Portland",
    "state": "OR",
    "profiles": [
      "sauce",
      "refrigerated-dip",
      "frozen"
    ],
    "moq": "",
    "website": "",
    "notes": "This company makes shelf-stable condiments and sauces, refrigerated items, and frozen products.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-210",
    "name": "Lisanatti Foods",
    "city": "Oregon City",
    "state": "OR",
    "profiles": [
      "refrigerated-dip"
    ],
    "moq": "Larger volumes only",
    "website": "",
    "notes": "They specialize in manufacturing and packaging vegan and plant-based cheese products.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-211",
    "name": "Oregon Hill Farms",
    "city": "St. Helens",
    "state": "OR",
    "profiles": [
      "sauce",
      "dry-seasoning"
    ],
    "moq": "",
    "website": "https://oregonhill.com",
    "notes": "This facility offers acidified canning, hot packing, and dry mixes and spices packaging.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-212",
    "name": "Rock Solid Manufacturing",
    "city": "Portland",
    "state": "OR",
    "profiles": [
      "sauce",
      "dry-seasoning"
    ],
    "moq": "",
    "website": "",
    "notes": "They handle liquid fill bottles, dry and liquid stick pack filling, pouch filling, and bag filling.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-213",
    "name": "St. Cousair, Inc.",
    "city": "Newberg",
    "state": "OR",
    "profiles": [
      "sauce",
      "frozen"
    ],
    "moq": "",
    "website": "",
    "notes": "They specialize in the production of jams, sauces, and other food products with capabilities for storage and freezing.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-214",
    "name": "Swift Cider",
    "city": "Portland",
    "state": "OR",
    "profiles": [
      "sauce",
      "frozen"
    ],
    "moq": "300 - 2200 gallons",
    "website": "",
    "notes": "They provide co-packing services for a variety of alcoholic and non-alcoholic beverages.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-215",
    "name": "West Coast CoPacker, Inc",
    "city": "Salem",
    "state": "OR",
    "profiles": [
      "dressing",
      "sauce",
      "refrigerated-dip",
      "salsa"
    ],
    "moq": "",
    "website": "",
    "notes": "They provide hot and cold fill production for a range of products including sauces, condiments, and beverages.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-216",
    "name": "Bumblebar",
    "city": "Spokane Valley",
    "state": "WA",
    "profiles": [
      "savory-snack"
    ],
    "moq": "",
    "website": "",
    "notes": "BumbleBar is an energy bar company.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-217",
    "name": "Cascade Range, LLC",
    "city": "Burlington",
    "state": "WA",
    "profiles": [
      "sauce",
      "dry-seasoning",
      "savory-snack"
    ],
    "moq": "",
    "website": "",
    "notes": "They offer co packing for jams, jellies, fruit butter, spice blends, granola, and fruit syrups.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-218",
    "name": "Kasilof Fish Company",
    "city": "Marysville",
    "state": "WA",
    "profiles": [
      "refrigerated-dip"
    ],
    "moq": "",
    "website": "",
    "notes": "They specialize in appetizers, pate, and smoked seafood.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-219",
    "name": "Noel Canning and Bottling",
    "city": "Yakima",
    "state": "WA",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "",
    "notes": "They are a beverage production facility and contract soft drink co-packer.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-220",
    "name": "Northwest Gourmet Foods",
    "city": "Renton",
    "state": "WA",
    "profiles": [
      "sauce"
    ],
    "moq": "",
    "website": "",
    "notes": "They have the equipment needed to process, label, and package your product.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-221",
    "name": "Pine Creek Pack",
    "city": "Omak",
    "state": "WA",
    "profiles": [
      "savory-snack"
    ],
    "moq": "",
    "website": "",
    "notes": "They specialize in organic and conventional dried fruit.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-222",
    "name": "San Gennaro Foods, Inc.",
    "city": "Kent",
    "state": "WA",
    "profiles": [
      "frozen"
    ],
    "moq": "",
    "website": "",
    "notes": "They co-pack grains, cereals, pasta, and other frozen foods.",
    "source": "PickYourOwn co-packer list"
  },
  {
    "id": "cm-223",
    "name": "Wolf Pack International",
    "city": "Gold Bar",
    "state": "WA",
    "profiles": [
      "sauce",
      "refrigerated-dip",
      "salsa",
      "dressing",
      "dry-seasoning"
    ],
    "moq": "",
    "website": "",
    "notes": "They accommodate a wide variety of food products including condiments, sauces, salsas, pickles, dips, and salad dressings.",
    "source": "PickYourOwn co-packer list"
  }
];
